import { render } from "./SalesTypeOfProducts.vue?vue&type=template&id=b39c52e4"
import script from "./SalesTypeOfProducts.vue?vue&type=script&lang=js"
export * from "./SalesTypeOfProducts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__